/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useModalControls } from '@hooks';
import { Button } from '@atoms';

import UploadModal from '../UploadModal';

const UploadMediaButton = ({ type, uploadButtonText = 'UPLOAD FILE', ...props }) => {
  const modal = useModalControls();

  return (
    <>
      <Button type={type ?? 'customBlue'} {...props} onClick={modal.show}>
        {uploadButtonText}
      </Button>
      <UploadModal {...modal} type="USERS" />
    </>
  );
};

export default UploadMediaButton;
